import {
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    FormControl,
    FormLabel,
    Input,
    ModalFooter,
    Text,
    Box,
    Image,
    Checkbox,
    Select,
    VStack,
    Divider,
    FormHelperText,
    useToast,
    HStack,
    Tag,
    TagLabel,
    TagCloseButton,
} from "@chakra-ui/react";
  import CompaniesApi from "../../../../api/companies"
  import { useEffect, useState } from "react";
import {useDropzone} from "react-dropzone";

// Helper function to convert onboarding status code to readable text
const getOnboardingStatusText = (status) => {
  switch (Number(status)) {
    case 100:
      return 'ממתין להגדרה (100)';
    case 200:
      return 'בתהליך הגדרה (200)';
    case 300:
      return 'הוגדר במלואו (300)';
    default:
      return 'לא מוגדר';
  }
};

export default function EditCompanyModal(props) {

    let { isOpen, onClose, company, callBack } = props;
    const [error, setError] = useState(undefined);
    const toast = useToast();

    const [name, setName] = useState("");
    const [displayName, setDisplayName] = useState("");
    const [legalName, setLegalName] = useState("");
    const [address, setAddress] = useState("");
    const [transferLimit, setTransferLimit] = useState("");
    const [employeesTransferDetailsProvider, setEmployeesTransferDetailsProvider] = useState("");
    const [govId, setGovId] = useState("");
    const [externalId, setExternalId] = useState("");
    const [fileSlug, setFileSlug] = useState("");
    const [employeesCount, setEmployeesCount] = useState("");
    const [invoicingProviderIdentifier, setInvoicingProviderIdentifier] = useState("");
    const [isSalaryOrginal, setIsSalaryOrginal] = useState(true);
    const [showShiftPayInApp, setShowShiftPayInApp] = useState(false);
    const [isAttendanceSet, setIsAttendanceSet] = useState(true);
    const [availableToTransferFactor, setAvailableToTransferFactor] = useState("");
    const [defaultTransferFee, setDefaultTransferFee] = useState("");
    const [subscriptionAmount, setSubscriptionAmount] = useState("");
    const [companyLogo, setCompanyLogo] = useState(null);
    const [onboardingStatus, setOnboardingStatus] = useState("");
    const [referralsEnabled, setReferralsEnabled] = useState(false);
    const [generalReferralsEnabled, setGeneralReferralsEnabled] = useState(false);
    const [generalReferralJobBonusAmount, setGeneralReferralJobBonusAmount] = useState("");
    const [contactEmails, setContactEmails] = useState([]);
    const [emailInput, setEmailInput] = useState("");


    useEffect(() => {
        if (isOpen) {
            setError(undefined); // Clear any previous errors
            if (company) {
                setName(company.name || "");
                setDisplayName(company.displayName || "");
                setLegalName(company.legalName || "");
                setAddress(company.address || "");
                setTransferLimit(company.employeesMonthlyTransferLimit || "");
                setEmployeesTransferDetailsProvider(company.employeesTransferDetailsProvider || "");
                setGovId(company.govId || "");
                setExternalId(company.externalId || "");
                setFileSlug(company.fileSlug || "");
                setEmployeesCount(company.employeesCount || "");
                setInvoicingProviderIdentifier(company.invoicingProviderIdentifier || "");
                setIsSalaryOrginal(company.isSalaryOrginal !== undefined ? company.isSalaryOrginal : true);
                setShowShiftPayInApp(company.showShiftPayInApp !== undefined ? company.showShiftPayInApp : false);
                setIsAttendanceSet(company.isAttendanceSet !== undefined ? company.isAttendanceSet : true);
                setAvailableToTransferFactor(company.availableToTransferFactor || "");
                setDefaultTransferFee(company.defaultTransferFee || "");
                setSubscriptionAmount(company.subscriptionAmount || "");
                setOnboardingStatus(company.onboardingStatus || "");
                setReferralsEnabled(company.referralsEnabled || false);
                setGeneralReferralsEnabled(company.generalReferralsEnabled || false);
                setGeneralReferralJobBonusAmount(company.generalReferralJobBonusAmount ?? "");
                setContactEmails(parseEmails(company.contactEmails));
                setEmailInput("");
                setCompanyLogo(company.logo || null);
            }
        } else {
            setName("");
            setDisplayName("");
            setLegalName("");
            setAddress("");
            setTransferLimit("");
            setEmployeesTransferDetailsProvider("");
            setGovId("");
            setExternalId("");
            setFileSlug("");
            setEmployeesCount("");
            setInvoicingProviderIdentifier("");
            setIsSalaryOrginal(true);
            setShowShiftPayInApp(false);
            setIsAttendanceSet(true);
            setAvailableToTransferFactor("");
            setDefaultTransferFee("");
            setSubscriptionAmount("");
            setOnboardingStatus("");
            setReferralsEnabled(false);
            setGeneralReferralsEnabled(false);
            setGeneralReferralJobBonusAmount("");
            setContactEmails([]);
            setEmailInput("");
            setCompanyLogo(null);
        }
    }, [isOpen, company]);

    const parseEmails = (raw) => {
        if (!raw) return [];
        if (Array.isArray(raw)) {
            return raw.map(e => e.trim().replace(/^\[|\]$/g, '')).filter(Boolean);
        }
        let s = String(raw).trim();
        if (s.startsWith('[') && s.endsWith(']')) s = s.slice(1, -1);
        return s.split(',').map(e => e.trim()).filter(Boolean);
    };

    const addEmail = () => {
        const trimmed = emailInput.trim();
        if (trimmed && !contactEmails.includes(trimmed)) {
            setContactEmails([...contactEmails, trimmed]);
        }
        setEmailInput("");
    };

    const removeEmail = (emailToRemove) => {
        setContactEmails(contactEmails.filter((e) => e !== emailToRemove));
    };

    const onDrop = (acceptedFiles) => {
        // Assuming only the first file is of interest
        const file = acceptedFiles[0];
        if (file) {
            // Create a preview URL for display
            setCompanyLogo(Object.assign(file, {
                preview: URL.createObjectURL(file)
            }));
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: 'image/jpeg, image/png', // Specify allowed file types
        maxFiles: 1, // Limit the number of files
    });

    const updateCompany = () => {
          setError(undefined)
          let companyJson = {
            "id": company.id
          }

          if(name) {
            companyJson["name"] = name;
          }
          if(displayName !== undefined) {
            companyJson["displayName"] = displayName;
          }
          if(legalName !== undefined) {
            companyJson["legalName"] = legalName;
          }
          if(address) {
            companyJson["address"] = address;
          }
          if(govId !== undefined) {
            companyJson["govId"] = govId;
          }
          if(externalId !== undefined) {
            companyJson["externalId"] = externalId;
          }
          if(fileSlug !== undefined) {
            companyJson["fileSlug"] = fileSlug;
          }
          if(employeesTransferDetailsProvider !== undefined && employeesTransferDetailsProvider !== "") {
            companyJson["employeesTransferDetailsProvider"] = Number(employeesTransferDetailsProvider);
          }
          if(transferLimit !== undefined && transferLimit !== ""){
              companyJson["transferLimit"] = Number(transferLimit);
          }
          if(employeesCount !== undefined && employeesCount !== "") {
            companyJson["employeesCount"] = Number(employeesCount);
          }
          if(invoicingProviderIdentifier !== undefined) {
            companyJson["invoicingProviderIdentifier"] = invoicingProviderIdentifier;
          }
          if(isSalaryOrginal !== undefined) {
            companyJson["isSalaryOrginal"] = isSalaryOrginal;
          }
          if(showShiftPayInApp !== undefined) {
            companyJson["showShiftPayInApp"] = showShiftPayInApp;
          }
          if(isAttendanceSet !== undefined) {
            companyJson["isAttendanceSet"] = isAttendanceSet;
          }
          if(availableToTransferFactor !== undefined && availableToTransferFactor !== "") {
            companyJson["availableToTransferFactor"] = Number(availableToTransferFactor);
          }
          if(defaultTransferFee !== undefined && defaultTransferFee !== "") {
            companyJson["defaultTransferFee"] = Number(defaultTransferFee);
          }
          if(subscriptionAmount !== undefined && subscriptionAmount !== "") {
            companyJson["subscriptionAmount"] = Number(subscriptionAmount);
          }
          if(onboardingStatus !== undefined && onboardingStatus !== "") {
            companyJson["onboardingStatus"] = Number(onboardingStatus);
          }
          if(referralsEnabled !== undefined) {
            companyJson["referralsEnabled"] = referralsEnabled;
          }
          companyJson["generalReferralsEnabled"] = generalReferralsEnabled;
          if (generalReferralJobBonusAmount !== "") {
            companyJson["generalReferralJobBonusAmount"] = Number(generalReferralJobBonusAmount);
          }
          companyJson["contactEmails"] = contactEmails;

        if(companyLogo && companyLogo instanceof File) {
            companyJson["companyLogo"] = companyLogo;
        }

          CompaniesApi.update(companyJson).then((response) => {
              console.log("Company update successful:", response);
              toast({
                title: "החברה עודכנה בהצלחה",
                position: 'top',
                status: 'success',
                duration: 3000,
                isClosable: true,
              });
              if (callBack) callBack(companyJson)
              onClose()
            })
            .catch(function (error) {
              console.log("Company update error:", error);
              if (error.response) {
                console.log("Error response:", error.response.data);
                const errorMessage = error.response.data?.message || error.response.statusText || "שגיאה לא ידועה";
                setError(`שגיאה: ${errorMessage}`);
                toast({
                  title: "שגיאה בעדכון החברה",
                  description: errorMessage,
                  position: 'top',
                  status: 'error',
                  duration: 5000,
                  isClosable: true,
                });
              } else {
                setError("שגיאה בחיבור לשרת");
                toast({
                  title: "שגיאה בחיבור לשרת",
                  position: 'top',
                  status: 'error',
                  duration: 5000,
                  isClosable: true,
                });
              }
            });

    }
    useEffect(() => () => {
        if (companyLogo && companyLogo.preview) {
            URL.revokeObjectURL(companyLogo.preview);
        }
    }, [companyLogo]);



    return (
        <Modal isOpen={isOpen}
         onClose={onClose}
         isCentered
         size="xl"
         scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent maxH="80vh">
          <ModalHeader>עריכת חברה</ModalHeader>
          <ModalBody>
          <h4 style={{
                fontSize: "1.2em",
                color: "red",
                textAlign: "center",
                fontWeight: 400,
                transition: ".2s all"}}>
              {error}
            </h4>
          <VStack spacing={4} align="stretch">
            {company && (
              <Box p={4} bg="gray.50" borderRadius="md" mb={4}>
                <Text fontWeight="bold" fontSize="lg" mb={2}>מידע נוכחי על החברה</Text>
                <Text fontSize="sm"><strong>שם:</strong> {company.name || 'לא מוגדר'}</Text>
                <Text fontSize="sm"><strong>שם תצוגה:</strong> {company.displayName || 'לא מוגדר'}</Text>
                <Text fontSize="sm"><strong>שם משפטי:</strong> {company.legalName || 'לא מוגדר'}</Text>
                <Text fontSize="sm"><strong>מזהה:</strong> {company.id}</Text>
                <Text fontSize="sm"><strong>ח.פ:</strong> {company.govId || 'לא מוגדר'}</Text>
                <Text fontSize="sm"><strong>מזהה חיצוני:</strong> {company.externalId || 'לא מוגדר'}</Text>
                <Text fontSize="sm"><strong>Slug לקבצים (אנגלית):</strong> {company.fileSlug || 'לא מוגדר'}</Text>
                <Text fontSize="sm"><strong>מספר עובדים:</strong> {company.employeesCount || 'לא מוגדר'}</Text>
                <Text fontSize="sm"><strong>מסגרת חודשית:</strong> {company.employeesMonthlyTransferLimit || 'לא מוגדר'}</Text>
                <Text fontSize="sm"><strong>מזהה ספק חשבוניות:</strong> {company.invoicingProviderIdentifier || 'לא מוגדר'}</Text>
                <Text fontSize="sm"><strong>סכום מנוי:</strong> ₪{company.subscriptionAmount || '0.00'}</Text>
                <Text fontSize="sm"><strong>סטטוס הרשמה:</strong> {getOnboardingStatusText(company.onboardingStatus)}</Text>
              </Box>
            )}

            <Divider />
            <FormLabel fontWeight='bold' fontSize='xl'>פרטי חברה בסיסיים</FormLabel>

            <FormControl>
              <FormLabel>שם חברה</FormLabel>
              <Input
                value={name}
                placeholder={company?.name || "הכנס שם חברה"}
                onChange={(event) => setName(event.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel>שם תצוגה</FormLabel>
              <Input
                value={displayName}
                placeholder={company?.displayName || "הכנס שם תצוגה"}
                onChange={(event) => setDisplayName(event.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel>שם משפטי</FormLabel>
              <Input
                value={legalName}
                placeholder={company?.legalName || "הכנס שם משפטי"}
                onChange={(event) => setLegalName(event.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel>כתובת</FormLabel>
              <Input
                value={address}
                placeholder={company?.address || "הכנס כתובת"}
                onChange={(event) => setAddress(event.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel>מספר ח.פ</FormLabel>
              <Input
                value={govId}
                placeholder={company?.govId || "הכנס מספר ח.פ"}
                onChange={(event) => setGovId(event.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel>מזהה חיצוני</FormLabel>
              <Input
                value={externalId}
                placeholder={company?.externalId || "הכנס מזהה חיצוני"}
                onChange={(event) => setExternalId(event.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Slug לקבצים (אנגלית, בלי רווחים)</FormLabel>
              <Input
                value={fileSlug}
                placeholder={company?.fileSlug || "e.g. Max-Stock-Petah-Tikva"}
                onChange={(event) => setFileSlug(event.target.value)}
              />
            </FormControl>

            <Divider />
            <FormLabel fontWeight='bold' fontSize='xl'>הגדרות עובדים</FormLabel>

            <FormControl>
              <FormLabel>מספר עובדים</FormLabel>
              <Input
                type="number"
                value={employeesCount}
                placeholder={company?.employeesCount?.toString() || "הכנס מספר עובדים"}
                onChange={(event) => setEmployeesCount(event.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel>מסגרת חודשית</FormLabel>
              <Input
                type="number"
                value={transferLimit}
                placeholder={company?.employeesMonthlyTransferLimit?.toString() || "הכנס מסגרת חודשית"}
                onChange={(event) => setTransferLimit(event.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel>ספק פרטי העברה</FormLabel>
              <Select
                value={employeesTransferDetailsProvider}
                placeholder={`נוכחי: ${company?.employeesTransferDetailsProvider === 1 ? 'חברה' : company?.employeesTransferDetailsProvider === 2 ? 'עובד' : 'לא מוגדר'}`}
                onChange={(event) => setEmployeesTransferDetailsProvider(event.target.value)}
              >
                <option value="">בחר ספק</option>
                <option value="1">חברה</option>
                <option value="2">עובד</option>
              </Select>
            </FormControl>

            <Divider />
            <FormLabel fontWeight='bold' fontSize='xl'>הגדרות כספיות</FormLabel>

            <FormControl>
              <FormLabel>אחוז זמין להעברה</FormLabel>
              <Input
                type="number"
                step="0.1"
                value={availableToTransferFactor}
                placeholder={company?.availableToTransferFactor?.toString() || "0.3"}
                onChange={(event) => setAvailableToTransferFactor(event.target.value)}
              />
              <FormHelperText>
                ערך נוכחי: {company?.availableToTransferFactor || '0.3'} (30% כברירת מחדל)
              </FormHelperText>
            </FormControl>

            <FormControl>
              <FormLabel>עמלת העברה ברירת מחדל</FormLabel>
              <Input
                type="number"
                step="0.01"
                value={defaultTransferFee}
                placeholder={company?.defaultTransferFee?.toString() || "9.50"}
                onChange={(event) => setDefaultTransferFee(event.target.value)}
              />
              <FormHelperText>
                ערך נוכחי: ₪{company?.defaultTransferFee || '9.50'}
              </FormHelperText>
            </FormControl>

            <FormControl>
              <FormLabel>סכום מנוי</FormLabel>
              <Input
                type="number"
                step="0.01"
                value={subscriptionAmount}
                placeholder={company?.subscriptionAmount?.toString() || "0.00"}
                onChange={(event) => setSubscriptionAmount(event.target.value)}
              />
              <FormHelperText>
                ערך נוכחי: ₪{company?.subscriptionAmount || '0.00'}
              </FormHelperText>
            </FormControl>

            <FormControl>
              <FormLabel>מזהה ספק חשבוניות</FormLabel>
              <Input
                value={invoicingProviderIdentifier}
                placeholder={company?.invoicingProviderIdentifier || "הכנס מזהה ספק חשבוניות"}
                onChange={(event) => setInvoicingProviderIdentifier(event.target.value)}
              />
            </FormControl>

            <Divider />
            <FormLabel fontWeight='bold' fontSize='xl'>הגדרות מערכת</FormLabel>

            <FormControl>
              <Checkbox isChecked={isSalaryOrginal} onChange={(event) => setIsSalaryOrginal(event.target.checked)}>
                משכורת מקורית
              </Checkbox>
              <Text fontSize="sm" color="gray.500" mt={1}>
                נוכחי: {company?.isSalaryOrginal ? 'כן' : 'לא'}
              </Text>
            </FormControl>

            <FormControl>
              <Checkbox isChecked={showShiftPayInApp} onChange={(event) => setShowShiftPayInApp(event.target.checked)}>
                הצג תשלום משמרת באפליקציה
              </Checkbox>
              <Text fontSize="sm" color="gray.500" mt={1}>
                נוכחי: {company?.showShiftPayInApp ? 'כן' : 'לא'}
              </Text>
            </FormControl>

            <FormControl>
              <Checkbox isChecked={isAttendanceSet} onChange={(event) => setIsAttendanceSet(event.target.checked)}>
                נוכחות מוגדרת
              </Checkbox>
              <Text fontSize="sm" color="gray.500" mt={1}>
                נוכחי: {company?.isAttendanceSet ? 'כן' : 'לא'}
              </Text>
            </FormControl>

            <FormControl>
              <Checkbox isChecked={referralsEnabled} onChange={(event) => setReferralsEnabled(event.target.checked)}>
                הפניות מופעלות (חבר מביא חבר)
              </Checkbox>
              <Text fontSize="sm" color="gray.500" mt={1}>
                נוכחי: {company?.referralsEnabled ? 'כן' : 'לא'}
              </Text>
            </FormControl>

            {referralsEnabled && (
              <FormControl>
                <Checkbox isChecked={generalReferralsEnabled} onChange={(event) => setGeneralReferralsEnabled(event.target.checked)}>
                  משרה כללית מופעלת
                </Checkbox>
                <Text fontSize="sm" color="gray.500" mt={1}>
                  נוכחי: {company?.generalReferralsEnabled ? 'כן' : 'לא'}
                </Text>
              </FormControl>
            )}
            {referralsEnabled && generalReferralsEnabled && (
              <FormControl>
                <FormLabel fontSize="sm">בונוס משרה כללית (₪)</FormLabel>
                <Input
                  type="number"
                  min="0"
                  placeholder="לדוגמה: 500"
                  value={generalReferralJobBonusAmount}
                  onChange={(e) => setGeneralReferralJobBonusAmount(e.target.value)}
                />
                <Text fontSize="sm" color="gray.500" mt={1}>
                  נוכחי: {company?.generalReferralJobBonusAmount ? `₪${company.generalReferralJobBonusAmount}` : 'לא הוגדר'}
                </Text>
              </FormControl>
            )}



            <Divider />
            <FormLabel fontWeight='bold' fontSize='xl'>אימיילים ליצירת קשר</FormLabel>

            {parseEmails(company?.contactEmails).length > 0 && (
                <VStack align="flex-start" spacing={1} mb={2}>
                    {parseEmails(company?.contactEmails).map((email) => (
                        <Text key={email} fontSize="sm" color="gray.500">{email}</Text>
                    ))}
                </VStack>
            )}
            {parseEmails(company?.contactEmails).length === 0 && (
                <Text fontSize="sm" color="gray.500" mb={2}>לא הוגדר</Text>
            )}

            <FormControl>
                <FormLabel>הוסף אימייל</FormLabel>
                <HStack>
                    <Input
                        value={emailInput}
                        placeholder="email@example.com"
                        onChange={(e) => setEmailInput(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addEmail(); } }}
                    />
                    <Button onClick={addEmail} flexShrink={0}>הוסף</Button>
                </HStack>
            </FormControl>

            {contactEmails.length > 0 && (
                <VStack align="flex-start" spacing={2} mt={2}>
                    {contactEmails.map((email) => (
                        <Tag key={email} size="md" colorScheme="blue" borderRadius="full">
                            <TagLabel>{email}</TagLabel>
                            <TagCloseButton onClick={() => removeEmail(email)} />
                        </Tag>
                    ))}
                </VStack>
            )}

            <Divider />
            <FormLabel fontWeight='bold' fontSize='xl'>סטטוס הרשמה</FormLabel>

            <FormControl>
              <FormLabel>סטטוס הרשמה</FormLabel>
              <Select
                value={onboardingStatus}
                placeholder="בחר סטטוס הרשמה"
                onChange={(event) => setOnboardingStatus(event.target.value)}
              >
                <option value={100}>ממתין להגדרה (100)</option>
                <option value={200}>בתהליך הגדרה (200)</option>
                <option value={300}>הוגדר במלואו (300)</option>
              </Select>
              <FormHelperText>
                סטטוס ההרשמה קובע האם החברה רואה את הממשק המלא או הודעת המתנה
              </FormHelperText>
            </FormControl>

            <Divider />
            <FormLabel fontWeight='bold' fontSize='xl'>לוגו חברה</FormLabel>
            <Box {...getRootProps()} p={5} border="2px dashed gray" borderRadius="md">
                <input {...getInputProps()} />
                <Text>גרור לוגו לכאן או לחץ ובחר קובץ נבחר</Text>
                {companyLogo && companyLogo.preview && (
                    <Box mt={3}>
                        <Image src={companyLogo.preview} alt="Preview" maxH="100px" />
                    </Box>
                )}
            </Box>
          </VStack>


          </ModalBody>
          <ModalFooter>
            <Button onClick={updateCompany}>שמור</Button>
            <Button onClick={onClose}>סגור</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
}
